<template>
  <!-- prettier-ignore -->
  <div
    class="ovp-fab-widget"
    :app-version="$version"
    :app-name="$options.name"
    :app-language="$i18n.locale"
  >
    <ovp-fab-container is-www />
  </div>
</template>
<script>
import Vue from '@/setup'

import OvpFabContainer from '@/components/Fab/Container'

export default Vue.extend({
  name: 'FabWidget',

  components: {
    OvpFabContainer,
  },
})
</script>

<style name="global" scoped>
* {
  & >>> button {
    font-family: Open Sans, sans-serif !important;
    font-weight: bold;
  }

  & >>> h3,
  & >>> h4 {
    font-family: Open Sans, sans-serif !important;
    color: var(--c-black);
    line-height: normal;
  }

  & >>> h3 {
    font-weight: bold;
  }

  & >>> h4 {
    font-size: 15px;
    margin-bottom: 2px;
  }
}
</style>
